import { UnknownAction } from "redux-saga";
import _ from "lodash";

import {
  ADD_LEARNER_TO_COURSE_REQUEST,
  ADDING_LEARNER_TO_COURSE_SUCCEEDED,
  ADDING_LEARNER_TO_COURSE_FAILED,
  FETCH_LEARNERS_REQUEST,
  FETCHING_LEARNERS_SUCCEEDED,
  FETCHING_LEARNERS_FAILED,
  INVALIDATE_LEARNERS_STATE,
  INVALIDATE_ADD_LEARNERS_STATE,
  FETCH_LEARNING_RECORD_COURSE_REQUEST,
  FETCHING_LEARNING_RECORD_COURSE_SUCCEEDED,
  FETCHING_LEARNING_RECORD_COURSE_FAILED,
  UPDATE_LESSON_PROGRESS_REQUEST,
  START_COURSE_REQUEST,
  STARTING_COURSE_SUCCEEDED,
  STARTING_COURSE_FAILED,
  INVALIDATE_START_COURSE,
  COMPLETE_COURSE_REQUEST,
  COMPLETING_COURSE_SUCCEEDED,
  COMPLETING_COURSE_FAILED,
  INVALIDATE_COMPLETE_COURSE,
  FETCHING_MY_COURSES_REQUEST,
  FETCHING_MY_COURSES_SUCCEEDED,
  FETCHING_MY_COURSES_FAILED,
  CREATE_COURSE_CONTENT_SESSION_REQUEST,
  CREATING_COURSE_CONTENT_SESSION_SUCCEEDED,
  CREATING_COURSE_CONTENT_SESSION_FAILED,
  INVALIDATE_COURSE_CONTENT_SESSION,
  RECORD_ANSWER_FOR_QUESTION_REQUEST,
  RECORD_QUESTION_SESSION_REQUEST,
  RECORDING_QUESTION_SESSION_SUCCEEDED,
  RECORDING_QUESTION_SESSION_FAILED,
  COMPLETE_COURSE_CONTENT_SESSION_REQUEST,
  COMPLETING_COURSE_CONTENT_SESSION_SUCCEEDED,
  COMPLETING_COURSE_CONTENT_SESSION_FAILED,
  FETCH_COURSE_CONTENT_SESSION_REQUEST,
  FETCHING_COURSE_CONTENT_SESSION_SUCCEEDED,
  FETCHING_COURSE_CONTENT_SESSION_FAILED,
  FETCH_ASSESSMENT_REPORT_REQUEST,
  FETCHING_ASSESSMENT_REPORT_SUCCEEDED,
  FETCHING_ASSESSMENT_REPORT_FAILED,
  UPDATE_COURSE_CONTENT_SESSION_REQUEST,
  UPDATING_COURSE_CONTENT_SESSION_SUCCEEDED,
  UPDATING_COURSE_CONTENT_SESSION_FAILED,
  UPDATING_COURSE_SESSION_SUCCEEDED,
  CREATE_LESSON_ANALYTICS_EVENT,
  CREATING_LESSON_ANALYTICS_EVENT_SUCCEEDED,
  CREATING_LESSON_ANALYTICS_EVENT_FAILED,
  FETCH_LEARNING_RECORD_SIMULATION_REQUEST,
  FETCHING_LEARNING_RECORD_SIMULATION_SUCCEEDED,
  FETCHING_LEARNING_RECORD_SIMULATION_FAILED,
  START_SIMULATION,
  STARTING_SIMULATION_SUCCEEDED,
  STARTING_SIMULATION_FAILED,
  INVALIDATE_START_SIMULATION,
  COMPLETE_SIMULATION,
  COMPLETING_SIMULATION_SUCCEEDED,
  COMPLETING_SIMULATION_FAILED,
  INVALIDATE_COMPLETE_SIMULATION,
  FETCH_SIMULATION_REPORT_REQUEST,
  FETCHING_SIMULATION_REPORT_SUCCEEDED,
  FETCHING_SIMULATION_REPORT_FAILED,
  RESTART_SIMULATION,
  RESTARTING_SIMULATION_SUCCEEDED,
  RESTARTING_SIMULATION_FAILED,
  INVALIDATE_RESTART_SIMULATION,
  FETCH_LESSON_FOR_LEARNING_RECORD_REQUEST,
  FETCHING_LESSON_FOR_LEARNING_RECORD_SUCCEEDED,
  FETCHING_LESSON_FOR_LEARNING_RECORD_FAILED,
  FETCH_LESSON_PREVIEW_FOR_LEARNING_RECORD_REQUEST,
  FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_SUCCEEDED,
  FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_FAILED,
  WS_SIMULATION_EVALUATION_COMPLETED,
  RETAKE_COURSE_REQUEST,
  RETAKING_COURSE_SUCCEEDED,
  RETAKING_COURSE_FAILED,
  INVALIDATE_RETAKE_COURSE,
  RETAKE_SIMULATION_REQUEST,
  RETAKING_SIMULATION_SUCCEEDED,
  RETAKING_SIMULATION_FAILED,
  FETCH_LEARNING_RECORD_PODCAST_REQUEST,
  FETCHING_LEARNING_RECORD_PODCAST_SUCCEEDED,
  FETCHING_LEARNING_RECORD_PODCAST_FAILED,
  FETCH_TRANSCRIPTS_FOR_LEARNING_PODCAST_REQUEST,
  FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_SUCCEEDED,
  FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_FAILED,
} from "../../actions/actionTypes";

import {
  Learner,
  AddLearnerToCourseError,
  LearningRecordCourse,
  UpdateLessonProgressRequest,
  StartCourseResponse,
  StartCourseErrorResponse,
  CompleteCourseResponse,
  CompleteCourseErrorResponse,
  FetchMyCoursesRequest,
  FetchMyCoursesResponse,
  LearningRecordCourseSummary,
  FetchMyCoursesErrorResponse,
  CreateCourseContentSessionRequest,
  CreateCourseContentSessionResponse,
  CreateCourseContentSessionErrorResponse,
  InvalidateCourseContentSession,
  RecordAnswerForQuestionRequest,
  RecordQuestionSessionRequest,
  RecordQuestionSessionResponse,
  RecordQuestionSessionErrorResponse,
  CompleteCourseContentSessionRequest,
  CompleteCourseContentSessionResponse,
  CompleteCourseContentSessionErrorResponse,
  FetchCourseContentSessionRequest,
  FetchCourseContentSessionResponse,
  FetchCourseContentSessionErrorResponse,
  FetchAssessmentReportRequest,
  FetchAssessmentReportResponse,
  FetchAssessmentReportErrorResponse,
  UpdateCourseContentSessionRequest,
  UpdateCourseContentSessionResponse,
  UpdateCourseContentSessionErrorResponse,
  UpdateCourseSessionResponse,
  CreateLessonAnalyticsRequest,
  CreateLessonAnalyticsResponse,
  CreateLessonAnalyticsErrorResponse,
  LearningRecordSimulation,
  FetchLearningRecordCourseResponse,
  FetchLearningRecordCourseErrorResponse,
  FetchLearningRecordSimulationResponse,
  FetchLearningRecordSimulationErrorResponse,
  StartSimulationResponse,
  StartSimulationErrorResponse,
  CompleteSimulationResponse,
  CompleteSimulationErrorResponse,
  FetchSimulationAssessmentReportRequest,
  FetchSimulationAssessmentReportResponse,
  FetchSimulationAssessmentReportErrorResponse,
  CompleteSimulationRequest,
  RestartSimulationResponse,
  RestartSimulationErrorResponse,
  FetchLessonForLearningRecordRequest,
  FetchLessonForLearningRecordResponse,
  FetchLessonForLearningRecordErrorResponse,
  FetchLessonPreviewForLearningRecordRequest,
  FetchLessonPreviewForLearningRecordResponse,
  FetchLessonPreviewForLearningRecordErrorResponse,
  SimulationAssessmentReport,
  EvaluationSimulationWebsocketResponse,
  RetakeCourseResponse,
  RetakeCourseErrorResponse,
  LearningRecordPodcast,
  FetchLearningRecordPodcastResponse,
  FetchLearningRecordPodcastErrorResponse,
} from "../../../types/coaching/learners";
import { Asset, PreviewAsset } from "src/types/assets";
import { GetPodcastTranscriptsErrorResponse, GetPodcastTranscriptsResponse, PodcastTranscripts } from "src/types/coaching/podcast";

const status_lookup = {
  IN_PROGRESS: "inProgress",
  NOT_STARTED: "notStarted",
  COMPLETED: "completed",
}

interface ContentAnalyticsState {
  recording: boolean,
  id: string,
  type: "lesson" | "assessment",
  percentComplete: number,
  session?: string,
  error: any
}

interface StartCourseState {
  starting: boolean,
  started: boolean,
  error: any
}

interface CompleteCourseState {
  completing: boolean,
  completed: boolean,
  error: any
}

interface RetakeCourseState {
  id: string;
  retaking: boolean,
  retaken: boolean,
  error: any
}

interface RetakeSimulationState {
  id: string;
  retaking: boolean,
  retaken: boolean,
  error: any
}

interface CourseState {
  loading: boolean,
  loaded: boolean,
  item: LearningRecordCourse | null,
  analytics: ContentAnalyticsState[],
  error: any
  start: null | StartCourseState,
  retake: null | RetakeCourseState,
  complete: null | CompleteCourseState,
  lessons: {
    [key: string]: AssetState
  },
}

interface AssetState {
  loading: boolean;
  item: Asset | null;
  preview: {
    loading: boolean;
    item: PreviewAsset | null;
    error: any;
  }
  error: any;
}

interface SimulationState {
  loading: boolean,
  loaded: boolean,
  item: LearningRecordSimulation | null,
  error: any
  start: null | StartSimulationState,
  restart: null | RestartSimulationState,
  retake: null | RetakeSimulationState,
  complete: null | CompleteSimulationState
  report: null | SimulationAssessmentReportState
}

interface StartSimulationState {
  starting: boolean,
  started: boolean,
  error: any
}

interface RestartSimulationState {
  restarting: boolean,
  restarted: boolean,
  error: any
}

interface CompleteSimulationState {
  completing: boolean,
  completed: boolean,
  error: any
}

interface SimulationAssessmentReportState {
  fetching: boolean,
  fetched: boolean,
  error: any
}

//Podcast

interface PodcastTranscriptsState {
  loading: boolean,
  loaded: boolean,
  item: PodcastTranscripts | null,
  error?: any,
}

interface PodcastState {
  loading: boolean,
  loaded: boolean,
  item: LearningRecordPodcast | null,
  error: any,
  transcripts?: PodcastTranscriptsState | null,
}

interface MyCoursesState {
  loading: boolean;
  loaded: boolean;
  items: LearningRecordCourseSummary[];
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  },
}

interface LearnersState {
  loading: boolean;
  loaded: boolean;
  items: Learner[];
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  },
  add: {
    loading: boolean;
    loaded: boolean;
    error: any;
  };
  courses: {
    notStarted: MyCoursesState;
    inProgress: MyCoursesState;
    completed: MyCoursesState;
  }
  course: {
    [key: string]: CourseState;
  },
  simulation: {
    [key: string]: SimulationState;
  },
  podcast: {
    [key: string]: PodcastState;
  },
  error: any;
}

const initialMyCoursesState: MyCoursesState = {
  loading: false,
  loaded: false,
  items: [],
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 10,
    totalRecordsCount: 0,
    hasMoreItems: false
  },
}

const initialState: LearnersState = {
  loading: false,
  loaded: false,
  items: [],
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 20,
    totalRecordsCount: 0,
    hasMoreItems: false
  },
  add: {
    loading: false,
    loaded: false,
    error: null
  },
  courses: {
    notStarted: initialMyCoursesState,
    inProgress: initialMyCoursesState,
    completed: initialMyCoursesState
  },
  course: {},
  simulation: {},
  podcast: {},
  error: null,
};

export function learnersReducer(state: LearnersState = initialState, action: UnknownAction): LearnersState {
  switch (action.type) {

    case ADD_LEARNER_TO_COURSE_REQUEST: {
      return {
        ...state,
        add: {
          ...state.add,
          loading: true,
          loaded: false
        }
      };
    }

    case ADDING_LEARNER_TO_COURSE_SUCCEEDED: {
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          loaded: true
        }
      };
    }

    case ADDING_LEARNER_TO_COURSE_FAILED: {
      const { error } = action.payload as AddLearnerToCourseError;
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          loaded: false,
          error: error
        }
      };
    }

    case FETCH_LEARNERS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }

    case FETCHING_LEARNERS_SUCCEEDED: {
      const { response } = action.payload as any;

      const existingItems: any[] = state.items || [];
      let records = response.records;
      if (response.currentPage > 0) {
        records = [...existingItems, ...records];
      }

      records = _.uniqBy(records, 'id');

      return {
        ...state,
        loading: false,
        items: records,
        pagination: {
          currentPage: response.currentPage,
          totalPages: response.totalPages,
          recordsPerPage: response.recordsPerPage,
          totalRecordsCount: response.totalRecordsCount,
          hasMoreItems: response.currentPage < response.totalPages - 1
        },
      };
    }

    case FETCHING_LEARNERS_FAILED: {
      const respponse = action.payload as any;
      return {
        ...state,
        loading: false,
        error: respponse.error,
      };
    }

    case INVALIDATE_LEARNERS_STATE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 20,
          totalRecordsCount: 0,
          hasMoreItems: false
        },
        add: {
          loading: false,
          loaded: false,
          error: null
        },
        error: null,
      };
    }

    case INVALIDATE_ADD_LEARNERS_STATE: {
      return {
        ...state,
        add: {
          loading: false,
          loaded: false,
          error: null
        },
      };
    }

    case FETCHING_MY_COURSES_REQUEST: {
      const { status } = action.payload as FetchMyCoursesRequest;

      const key = status_lookup[status];

      const courseState = state.courses[key];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        courses: {
          ...state.courses,
          [key]: {
            ...courseState,
            loading: true,
            loaded: false,
            error: null,
          }
        },
      };
    }

    case FETCHING_MY_COURSES_SUCCEEDED: {
      const { status, response } = action.payload as FetchMyCoursesResponse;

      const key = status_lookup[status];

      const courseState = state.courses[key] as MyCoursesState;
      if (!courseState) {
        return state;
      }

      const existingItems: LearningRecordCourseSummary[] = courseState.items;
      let records = response.records;
      if (response.currentPage > 0) {
        records = [...existingItems, ...records];
      }

      records = _.uniqBy(records, 'id');


      return {
        ...state,
        courses: {
          ...state.courses,
          [key]: {
            ...courseState,
            loading: false,
            loaded: true,
            items: records,
            pagination: {
              currentPage: response.currentPage,
              totalPages: response.totalPages,
              recordsPerPage: response.recordsPerPage,
              totalRecordsCount: response.totalRecordsCount,
              hasMoreItems: response.currentPage < response.totalPages - 1
            },
            error: null,
          }
        },
      };
    }


    case FETCHING_MY_COURSES_FAILED: {
      const { status, error } = action.payload as FetchMyCoursesErrorResponse;

      const key = status_lookup[status];

      const courseState = state.courses[key];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        courses: {
          ...state.courses,
          [key]: {
            ...courseState,
            loading: false,
            loaded: false,
            error: error,
          }
        },
      };
    }

    case FETCH_LEARNING_RECORD_COURSE_REQUEST: {
      const id = action.payload as string;

      const courseState = state.course[id] || {
        loading: false,
        loaded: false,
        item: null,
        error: null
      };

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            loading: true,
            loaded: false,
            error: null,
            lessons: {},
          }
        }
      }
    }

    case FETCHING_LEARNING_RECORD_COURSE_SUCCEEDED: {
      const { response } = action.payload as FetchLearningRecordCourseResponse;

      if (!response || !response.id) {
        return state;
      }

      const courseState = state.course[response.id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [response.id]: {
            ...courseState,
            loading: false,
            loaded: true,
            item: {
              ...response,
            },
            lessons: {},
          }
        }
      }
    }

    case FETCHING_LEARNING_RECORD_COURSE_FAILED: {
      const { id, error } = action.payload as FetchLearningRecordCourseErrorResponse;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            loading: false,
            loaded: false,
            item: null,
            error: error
          }
        }
      }
    }

    case FETCH_LESSON_FOR_LEARNING_RECORD_REQUEST: {
      const { learningRecord, lesson } = action.payload as FetchLessonForLearningRecordRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      let lessonState = courseState.lessons[lesson];
      if (!lessonState) {
        lessonState = {
          loading: false,
          item: null,
          error: null,
          preview: {
            loading: false,
            item: null,
            error: null
          }
        }
      }

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            lessons: {
              ...courseState.lessons,
              [lesson]: {
                ...lessonState,
                loading: true,
                item: null,
                error: null
              }
            }
          }
        }
      }
    }

    case FETCHING_LESSON_FOR_LEARNING_RECORD_SUCCEEDED: {
      const { learningRecord, lesson, asset } = action.payload as FetchLessonForLearningRecordResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const lessonState = courseState.lessons[lesson];
      if (!lessonState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            lessons: {
              ...courseState.lessons,
              [lesson]: {
                ...lessonState,
                loading: false,
                item: asset,
                error: null
              }
            }
          }
        }
      }
    }

    case FETCHING_LESSON_FOR_LEARNING_RECORD_FAILED: {
      const { learningRecord, lesson, error } = action.payload as FetchLessonForLearningRecordErrorResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const lessonState = courseState.lessons[lesson];
      if (!lessonState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            lessons: {
              ...courseState.lessons,
              [lesson]: {
                ...lessonState,
                loading: false,
                item: null,
                error: error,
              }
            }
          }
        }
      }
    }

    case FETCH_LESSON_PREVIEW_FOR_LEARNING_RECORD_REQUEST: {
      const { learningRecord, lesson } = action.payload as FetchLessonPreviewForLearningRecordRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const lessonState = courseState.lessons[lesson];
      if (!lessonState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            lessons: {
              ...courseState.lessons,
              [lesson]: {
                ...lessonState,
                preview: {
                  ...lessonState.preview,
                  loading: true,
                }
              }
            }
          }
        }
      }
    }

    case FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_SUCCEEDED: {
      const { learningRecord, lesson, preview } = action.payload as FetchLessonPreviewForLearningRecordResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const lessonState = courseState.lessons[lesson];
      if (!lessonState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            lessons: {
              ...courseState.lessons,
              [lesson]: {
                ...lessonState,
                preview: {
                  ...lessonState.preview,
                  loading: false,
                  item: preview,
                  error: null
                }
              }
            }
          }
        }
      }
    }

    case FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_FAILED: {
      const { learningRecord, lesson, error } = action.payload as FetchLessonPreviewForLearningRecordErrorResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const lessonState = courseState.lessons[lesson];
      if (!lessonState) {
        return state;
      }


      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            lessons: {
              ...courseState.lessons,
              [lesson]: {
                ...lessonState,
                preview: {
                  ...lessonState.preview,
                  loading: false,
                  item: null,
                  error: error
                }
              }
            }
          }
        }
      }
    }

    case UPDATE_LESSON_PROGRESS_REQUEST: {
      const { lesson, learningRecord, progress } = action.payload as UpdateLessonProgressRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      let existingItems = [...(courseState.analytics || [])];
      const existingItem = existingItems.find((a) => a.id === lesson && a.type === "lesson");
      if (!existingItem) {
        existingItems = [...existingItems, {
          recording: false,
          id: lesson,
          type: "lesson",
          percentComplete: progress,
          error: null
        }]
      } else {
        existingItems = existingItems.map((a) => {
          if (a.id === lesson && a.type === "lesson") {
            return {
              ...a,
              recording: false,
              percentComplete: progress,
            }
          }
          return a;
        });
      }


      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            analytics: existingItems
          }
        }
      }
    }

    case CREATE_COURSE_CONTENT_SESSION_REQUEST: {
      const { learningRecord, id, type } = action.payload as CreateCourseContentSessionRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }


      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === id && a.type === type);
      if (!existingItem) {
        existingItems = [...existingItems, {
          creating: true,
          id: id,
          type: type,
          percentCompleted: 0,
          duration: 0,
          error: null
        }]
      } else {
        existingItems = existingItems.map((a) => {
          if (a.id === id && a.type === type) {
            return {
              ...a,
              recording: true
            }
          }
          return a;
        });
      }


      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case CREATING_COURSE_CONTENT_SESSION_SUCCEEDED: {
      const { learningRecord, response } = action.payload as CreateCourseContentSessionResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === response.id && a.type === response.type);
      if (!existingItem) {
        existingItems = [...existingItems, {
          creating: false,
          created: true,
          error: null,
          ...response,
        }]
      } else {
        existingItems = existingItems.map((a) => {
          if (a.id === response.id && a.type === response.type) {
            return {
              ...a,
              creating: false,
              created: true,
              ...response
            }
          }
          return a;
        });
      }


      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case CREATING_COURSE_CONTENT_SESSION_FAILED: {
      const { learningRecord, id, type, error } = action.payload as CreateCourseContentSessionErrorResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === id && a.type === type);
      if (existingItem) {
        existingItems = existingItems.map((a) => {
          if (a.id === id && a.type === type) {
            return {
              ...a,
              creating: false,
              error: error
            }
          }
          return a;
        });
      }


      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case UPDATE_COURSE_CONTENT_SESSION_REQUEST: {
      const { learningRecord, id, type } = action.payload as UpdateCourseContentSessionRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }


      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === id && a.type === type);
      if (!existingItem) {
        existingItems = [...existingItems, {
          creating: true,
          id: id,
          type: type,
          percentCompleted: 0,
          duration: 0,
          error: null
        }]
      } else {
        existingItems = existingItems.map((a) => {
          if (a.id === id && a.type === type) {
            return {
              ...a,
              recording: true
            }
          }
          return a;
        });
      }

      _.uniqBy(existingItems, 'id');

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case UPDATING_COURSE_CONTENT_SESSION_SUCCEEDED: {
      const { learningRecord, response } = action.payload as UpdateCourseContentSessionResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === response.id && a.type === response.type);
      if (!existingItem) {
        existingItems = [...existingItems, {
          creating: false,
          created: true,
          error: null,
          ...response,
        }]
      } else {
        existingItems = existingItems.map((a) => {
          if (a.id === response.id && a.type === response.type) {
            return {
              ...a,
              updating: false,
              updated: true,
              duration: response.duration,
              percentCompleted: response.percentCompleted,
            }
          }
          return a;
        });
      }


      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case UPDATING_COURSE_CONTENT_SESSION_FAILED: {
      const { learningRecord, id, type, error } = action.payload as UpdateCourseContentSessionErrorResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === id && a.type === type);
      if (existingItem) {
        existingItems = existingItems.map((a) => {
          if (a.id === id && a.type === type) {
            return {
              ...a,
              updating: false,
              error: error
            }
          }
          return a;
        });
      }


      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case FETCH_COURSE_CONTENT_SESSION_REQUEST: {
      const { learningRecord, id, type } = action.payload as FetchCourseContentSessionRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }


      let existingItems = [...(course.sessions || [])];

      existingItems = existingItems.map((a) => {
        if (a.id === id && a.type === type) {
          return {
            ...a,
            fetching: true,
            fetched: false,
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case FETCHING_COURSE_CONTENT_SESSION_SUCCEEDED: {
      const { learningRecord, response } = action.payload as FetchCourseContentSessionResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];

      existingItems = existingItems.map((a) => {
        if (a.id === response.id && a.type === response.type) {
          return {
            ...a,
            fetching: false,
            fetched: true,
            ...response
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case FETCHING_COURSE_CONTENT_SESSION_FAILED: {
      const { learningRecord, id, type, error } = action.payload as FetchCourseContentSessionErrorResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      existingItems = existingItems.map((a) => {
        if (a.id === id && a.type === type) {
          return {
            ...a,
            fetching: false,
            error: error
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case FETCH_ASSESSMENT_REPORT_REQUEST: {
      const { learningRecord, id, type } = action.payload as FetchAssessmentReportRequest;
      console.log(learningRecord, id, type);

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }


      let existingItems = [...(course.sessions || [])];

      existingItems = existingItems.map((a) => {
        if (a.id === id && a.type === type) {
          return {
            ...a,
            fetchingReport: true,
            fetchedReport: false,
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case FETCHING_ASSESSMENT_REPORT_SUCCEEDED: {
      const { learningRecord, response } = action.payload as FetchAssessmentReportResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];

      existingItems = existingItems.map((a) => {
        if (a.id === response.id && a.type === "assessment") {
          return {
            ...a,
            fetchingReport: false,
            fetchedReport: true,
            report: response
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case FETCHING_ASSESSMENT_REPORT_FAILED: {
      const { learningRecord, id, type, error } = action.payload as FetchAssessmentReportErrorResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      existingItems = existingItems.map((a) => {
        if (a.id === id && a.type === type) {
          return {
            ...a,
            fetching: false,
            error: error
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case COMPLETE_COURSE_CONTENT_SESSION_REQUEST: {
      const { learningRecord, id, type } = action.payload as CompleteCourseContentSessionRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      existingItems = existingItems.map((a) => {
        if (a.id === id && a.type === type) {
          return {
            ...a,
            completing: true,
            completed: false,
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case COMPLETING_COURSE_CONTENT_SESSION_SUCCEEDED: {
      const { learningRecord, response } = action.payload as CompleteCourseContentSessionResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      existingItems = existingItems.map((a) => {
        if (a.id === response.id && a.type === response.type) {
          return {
            ...a,
            completing: false,
            completed: true,
            status: response.status,
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case COMPLETING_COURSE_CONTENT_SESSION_FAILED: {
      const { learningRecord, id, type, error } = action.payload as CompleteCourseContentSessionErrorResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      existingItems = existingItems.map((a) => {
        if (a.id === id && a.type === type) {
          return {
            ...a,
            completing: false,
            completed: false,
            error: error
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case INVALIDATE_COURSE_CONTENT_SESSION: {
      const { learningRecord, id, type, } = action.payload as InvalidateCourseContentSession;
      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      existingItems = existingItems.map((a) => {
        if (a.id === id && a.type === type) {
          return {
            ...a,
            creating: false,
            created: false,
            updating: false,
            updated: false,
            completing: false,
            completed: false,
            fetching: false,
            fetched: false,
            fetchingReport: false,
            fetchedReport: false,
            error: null
          }
        }
        return a;
      });

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case RECORD_ANSWER_FOR_QUESTION_REQUEST: {
      const { learningRecord, assessment, question, answer } = action.payload as RecordAnswerForQuestionRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === assessment && a.type === "assessment");
      if (existingItem) {
        existingItems = existingItems.map((a) => {
          if (a.id === assessment && a.type === "assessment") {
            let questions = a.questions || [];
            const questionItem = questions.find((q) => q.question === question);
            if (!questionItem) {
              questions = [...questions, {
                id: null,
                question: question,
                answer: answer,
                duration: 0,
                creating: false,
                created: false,
                changed: true,
                error: null
              }]
            } else {
              questions = questions.map((q) => {
                if (q.question === question) {
                  return {
                    ...q,
                    answer: answer,
                    changed: true
                  }
                }

                return q;
              });
            }

            return {
              ...a,
              questions: questions
            }
          }
          return a;
        });
      }

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case RECORD_QUESTION_SESSION_REQUEST: {
      const { learningRecord, assessment, question, answer } = action.payload as RecordQuestionSessionRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === assessment && a.type === "assessment");
      if (existingItem) {
        existingItems = existingItems.map((a) => {
          if (a.id === assessment && a.type === "assessment") {
            let questions = a.questions || [];
            const questionItem = questions.find((q) => q.question === question);
            if (!questionItem) {
              questions = [...questions, {
                id: null,
                question: question,
                answer: answer,
                duration: 0,
                creating: true,
                created: false,
                changed: true,
                error: null
              }]
            } else {
              questions = questions.map((q) => {
                if (q.question === question) {
                  return {
                    ...q,
                    answer: answer,
                    creating: true,
                  }
                }

                return q;
              });
            }

            return {
              ...a,
              questions: questions
            }
          }
          return a;
        });
      }

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case RECORDING_QUESTION_SESSION_SUCCEEDED: {
      const { learningRecord, assessment, question } = action.payload as RecordQuestionSessionResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === assessment && a.type === "assessment");
      if (existingItem) {
        existingItems = existingItems.map((a) => {
          if (a.id === assessment && a.type === "assessment") {
            let questions = a.questions || [];

            questions = questions.map((q) => {
              if (q.question === question) {
                return {
                  ...q,
                  creating: false,
                  created: true,
                  changed: false,
                }
              }

              return q;
            });

            return {
              ...a,
              questions: questions
            }
          }
          return a;
        });
      }

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case RECORDING_QUESTION_SESSION_FAILED: {
      const { learningRecord, assessment, question, error } = action.payload as RecordQuestionSessionErrorResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === assessment && a.type === "assessment");
      if (existingItem) {
        existingItems = existingItems.map((a) => {
          if (a.id === assessment && a.type === "assessment") {
            let questions = a.questions || [];

            questions = questions.map((q) => {
              if (q.question === question) {
                return {
                  ...q,
                  creating: false,
                  created: true,
                  changed: false,
                  error: error
                }
              }

              return q;
            });

            return {
              ...a,
              questions: questions
            }
          }
          return a;
        });
      }

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case START_COURSE_REQUEST: {
      const id = action.payload as string;
      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            start: {
              starting: true,
              started: false,
              error: null
            }
          }
        }
      }
    }

    case STARTING_COURSE_SUCCEEDED: {
      const { id, status, startedDate } = action.payload as StartCourseResponse;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            item: {
              ...courseState.item!,
              status: status,
              startedDate: startedDate
            },
            start: {
              starting: false,
              started: true,
              error: null
            }
          }
        }
      }
    }

    case STARTING_COURSE_FAILED: {
      const { id, error } = action.payload as StartCourseErrorResponse;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            start: {
              starting: false,
              started: false,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_START_COURSE: {
      const id = action.payload as string;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            start: null
          }
        }
      }
    }

    case RETAKE_COURSE_REQUEST: {
      const id = action.payload as string;
      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            retake: {
              id: id,
              retaking: true,
              retaken: false,
              error: null,
            },
          },
        },
      };
    }

    case RETAKING_COURSE_SUCCEEDED: {
      const { id, course, status, startedDate } = action.payload as RetakeCourseResponse;

      const courseState = state.course[course];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [course]: {
            ...courseState,
            item: {
              ...courseState.item!,
              status: status,
              startedDate: startedDate,
            },
            retake: {
              id: id,
              retaking: false,
              retaken: true,
              error: null,
            },
          },
        },
      };
    }

    case RETAKING_COURSE_FAILED: {
      const { id, error } = action.payload as RetakeCourseErrorResponse;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            retake: {
              id: id,
              retaking: false,
              retaken: false,
              error: error,
            },
          },
        },
      };
    }

    case INVALIDATE_RETAKE_COURSE: {
      const id = action.payload as string;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            retake: null
          }
        }
      }
    }

    case UPDATING_COURSE_SESSION_SUCCEEDED: {
      const { id, modifiedDate } = action.payload as UpdateCourseSessionResponse;
      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            item: {
              ...courseState.item!,
              modifiedDate: modifiedDate
            },
          }
        }
      }
    }

    case COMPLETE_COURSE_REQUEST: {
      const { id } = action.payload as CompleteCourseResponse;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            complete: {
              completing: true,
              completed: false,
              error: null
            }
          }
        }
      }
    }

    case COMPLETING_COURSE_SUCCEEDED: {
      const { id, status, completedDate } = action.payload as CompleteCourseResponse;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            item: {
              ...courseState.item!,
              status: status,
              completedDate: completedDate
            },
            complete: {
              completing: false,
              completed: true,
              error: null
            }
          }
        }
      }
    }

    case COMPLETING_COURSE_FAILED: {
      const { id, error } = action.payload as CompleteCourseErrorResponse;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            complete: {
              completing: false,
              completed: false,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_COMPLETE_COURSE: {
      const id = action.payload as string;

      const courseState = state.course[id];
      if (!courseState) {
        return state;
      }

      return {
        ...state,
        course: {
          ...state.course,
          [id]: {
            ...courseState,
            complete: null
          }
        }
      }
    }

    case CREATE_LESSON_ANALYTICS_EVENT: {
      const { learningRecord, lesson } = action.payload as CreateLessonAnalyticsRequest;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      const existingItem = existingItems.find((a) => a.id === lesson && a.type === "lesson");
      if (!existingItem) {
        existingItems = [...existingItems, {
          creating: false,
          creatingAnalytics: true,
          id: lesson,
          type: "lesson",
          percentCompleted: 0,
          duration: 0,
          error: null
        }]
      } else {
        existingItems = existingItems.map((a) => {
          if (a.id === lesson && a.type === "lesson") {
            return {
              ...a,
              creatingAnalytics: true
            }
          }
          return a;
        });
      }

      _.uniqBy(existingItems, "id");

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case CREATING_LESSON_ANALYTICS_EVENT_SUCCEEDED: {
      const { learningRecord, lesson, response } = action.payload as CreateLessonAnalyticsResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      existingItems = existingItems.map((a) => {
        if (a.id === lesson && a.type === "lesson") {
          return {
            ...a,
            creatingAnalytics: false,
            analyticsSession: response.id,
          }
        }
        return a;
      });

      _.uniqBy(existingItems, "id");

      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    case CREATING_LESSON_ANALYTICS_EVENT_FAILED: {
      const { learningRecord, lesson, error } = action.payload as CreateLessonAnalyticsErrorResponse;

      const courseState = state.course[learningRecord];
      if (!courseState) {
        return state;
      }

      const course = courseState.item;
      if (!course) {
        return state;
      }

      let existingItems = [...(course.sessions || [])];
      existingItems = existingItems.map((a) => {
        if (a.id === lesson && a.type === "lesson") {
          return {
            ...a,
            creatingAnalytics: false,
            error: error
          }
        }
        return a;
      });


      return {
        ...state,
        course: {
          ...state.course,
          [learningRecord]: {
            ...courseState,
            item: {
              ...course,
              sessions: existingItems
            }
          }
        }
      }
    }

    //Simulation
    case FETCH_LEARNING_RECORD_SIMULATION_REQUEST: {
      const id = action.payload as string;

      const simulationState = state.simulation[id] || {
        loading: false,
        loaded: false,
        item: null,
        error: null
      };

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            loading: true,
            loaded: false,
            error: null
          }
        }
      }
    }

    case FETCHING_LEARNING_RECORD_SIMULATION_SUCCEEDED: {
      const { response } = action.payload as FetchLearningRecordSimulationResponse;

      if (!response || !response.id) {
        return state;
      }

      const simulationState = state.simulation[response.id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [response.id]: {
            ...simulationState,
            loading: false,
            loaded: true,
            item: {
              ...response,
            },
            error: null,
          }
        }
      }
    }

    case FETCHING_LEARNING_RECORD_SIMULATION_FAILED: {
      const { id, error } = action.payload as FetchLearningRecordSimulationErrorResponse;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            loading: false,
            loaded: false,
            item: null,
            error: error
          }
        }
      }
    }

    case START_SIMULATION: {
      const id = action.payload as string;
      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            start: {
              starting: true,
              started: false,
              error: null
            }
          }
        }
      }
    }

    case STARTING_SIMULATION_SUCCEEDED: {
      const { id, status, startedDate, callConfig, session } = action.payload as StartSimulationResponse;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            item: {
              ...simulationState.item!,
              status: status,
              startedDate: startedDate,
              session: session,
              callConfig: callConfig
            },
            start: {
              starting: false,
              started: true,
              error: null
            }
          }
        }
      }
    }

    case STARTING_SIMULATION_FAILED: {
      const { id, error } = action.payload as StartSimulationErrorResponse;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            start: {
              starting: false,
              started: false,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_START_SIMULATION: {
      const id = action.payload as string;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            start: null
          }
        }
      }
    }

    case RESTART_SIMULATION: {
      const id = action.payload as string;
      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            item: {
              ...simulationState.item!,
              session: undefined,
            },
            restart: {
              restarting: true,
              restarted: false,
              error: null
            }
          }
        }
      }
    }

    case RESTARTING_SIMULATION_SUCCEEDED: {
      const { id, status, startedDate, callConfig, session } = action.payload as RestartSimulationResponse;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            item: {
              ...simulationState.item!,
              status: status,
              startedDate: startedDate,
              session: session,
              callConfig: callConfig
            },
            restart: {
              restarting: false,
              restarted: true,
              error: null
            }
          }
        }
      }
    }

    case RESTARTING_SIMULATION_FAILED: {
      const { id, error } = action.payload as RestartSimulationErrorResponse;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            restart: {
              restarting: false,
              restarted: false,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_RESTART_SIMULATION: {
      const id = action.payload as string;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            restart: null
          }
        }
      }
    }

    case COMPLETE_SIMULATION: {
      const { id } = action.payload as CompleteSimulationRequest;

      const simulationState = state.simulation[id];

      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            complete: {
              completing: true,
              completed: false,
              error: null
            }
          }
        }
      }
    }

    case COMPLETING_SIMULATION_SUCCEEDED: {
      const { id, status, completedDate, duration, percentage, report } = action.payload as CompleteSimulationResponse;

      const simulationState = state.simulation[id];

      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            item: {
              ...simulationState.item!,
              session: undefined,
              status: status,
              completedDate: completedDate,
              duration: duration,
              percentage: percentage,
              report: report
            },
            complete: {
              completing: false,
              completed: true,
              error: null
            }
          }
        }
      }
    }

    case COMPLETING_SIMULATION_FAILED: {
      const { id, error } = action.payload as CompleteSimulationErrorResponse;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            complete: {
              completing: false,
              completed: false,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_COMPLETE_SIMULATION: {
      const id = action.payload as string;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            complete: null
          }
        }
      }
    }

    case WS_SIMULATION_EVALUATION_COMPLETED: {
      const { learningRecord, report } = action.payload as EvaluationSimulationWebsocketResponse;

      const simulationState = state.simulation[learningRecord];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [learningRecord]: {
            ...simulationState,
            item: {
              ...simulationState.item!,
              report: report
            }
          }
        }
      }
    }

    case FETCH_SIMULATION_REPORT_REQUEST: {
      const { id } = action.payload as FetchSimulationAssessmentReportRequest;
      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            report: {
              fetching: true,
              fetched: false,
              error: null
            }
          }
        }
      }
    }

    case FETCHING_SIMULATION_REPORT_SUCCEEDED: {
      const { id, response } = action.payload as FetchSimulationAssessmentReportResponse;
      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            item: {
              ...simulationState.item!,
              report: response
            },
            report: {
              fetching: false,
              fetched: true,
              error: null
            }
          }
        }
      }
    }

    case FETCHING_SIMULATION_REPORT_FAILED: {
      const { id, error } = action.payload as FetchSimulationAssessmentReportErrorResponse;
      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            report: {
              fetching: false,
              fetched: false,
              error: error
            }
          }
        }
      }
    }

    case RETAKE_SIMULATION_REQUEST: {
      const id = action.payload as string;
      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            retake: {
              id: id,
              retaking: true,
              retaken: false,
              error: null,
            },
          },
        },
      };
    }

    case RETAKING_SIMULATION_SUCCEEDED: {
      const { id, course, status, startedDate } = action.payload as RetakeCourseResponse;

      const simulationState = state.simulation[course];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [course]: {
            ...simulationState,
            item: {
              ...simulationState.item!,
              id: id,
              status: status,
              startedDate: startedDate,
            },
            retake: {
              id: id,
              retaking: false,
              retaken: true,
              error: null,
            },
          },
        },
      };
    }

    case RETAKING_SIMULATION_FAILED: {
      const { id, error } = action.payload as RetakeCourseErrorResponse;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            retake: {
              id: id,
              retaking: false,
              retaken: false,
              error: error,
            },
          },
        },
      };
    }

    // Podcast
    case FETCH_LEARNING_RECORD_PODCAST_REQUEST: {
      const id = action.payload as string;

      const podcastState = state.podcast[id] || {
        loading: false,
        loaded: false,
        item: null,
        error: null
      };

      return {
        ...state,
        podcast: {
          ...state.podcast,
          [id]: {
            ...podcastState,
            loading: true,
            loaded: false,
            error: null,
          }
        }
      }
    }

    case FETCHING_LEARNING_RECORD_PODCAST_SUCCEEDED: {
      const { response } = action.payload as FetchLearningRecordPodcastResponse;

      if (!response || !response.id) {
        return state;
      }

      const podcastState = state.podcast[response.id];
      if (!podcastState) {
        return state;
      }

      return {
        ...state,
        podcast: {
          ...state.podcast,
          [response.id]: {
            ...podcastState,
            loading: false,
            loaded: true,
            item: {
              ...response,
            }
          }
        }
      }
    }

    case FETCHING_LEARNING_RECORD_PODCAST_FAILED: {
      const { id, error } = action.payload as FetchLearningRecordPodcastErrorResponse;

      const podcastState = state.podcast[id];
      if (!podcastState) {
        return state;
      }

      return {
        ...state,
        podcast: {
          ...state.podcast,
          [id]: {
            ...podcastState,
            loading: false,
            loaded: false,
            item: null,
            error: error
          }
        }
      }
    }

    case FETCH_TRANSCRIPTS_FOR_LEARNING_PODCAST_REQUEST: {
      const id = action.payload as string;

      const podcastState = state.podcast[id];
      if (!podcastState) {
        return state;
      }

      return {
        ...state,
        podcast: {
          ...state.podcast,
          [id]: {
            ...podcastState,
            transcripts: {
              loading: true,
              loaded: false,
              item: null,
              error: null,
            }
          }
        }
      }
    }

    case FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_SUCCEEDED: {
      const { id, response } = action.payload as GetPodcastTranscriptsResponse;

      if (!response || !id) {
        return state;
      }

      const podcastState = state.podcast[id];
      if (!podcastState) {
        return state;
      }

      return {
        ...state,
        podcast: {
          ...state.podcast,
          [id]: {
            ...podcastState,
            transcripts: {
              loading: false,
              loaded: true,
              item: response,
              error: null,
            }
          }
        }
      };
    }

    case FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_FAILED: {
      const { id, error } = action.payload as GetPodcastTranscriptsErrorResponse;

      const podcastState = state.podcast[id];
      if (!podcastState) {
        return state;
      }

      return {
        ...state,
        podcast: {
          ...state.podcast,
          [id]: {
            ...podcastState,
            transcripts: {
              loading: false,
              loaded: false,
              item: null,
              error: error,
            }
          }
        }
      };
    }

    default:
      return state;
  }
};
